import { render, staticRenderFns } from "./ResearchDataTable.vue?vue&type=template&id=524f4c31&scoped=true&"
import script from "./ResearchDataTable.vue?vue&type=script&lang=js&"
export * from "./ResearchDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ResearchDataTable.vue?vue&type=style&index=0&id=524f4c31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f4c31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524f4c31')) {
      api.createRecord('524f4c31', component.options)
    } else {
      api.reload('524f4c31', component.options)
    }
    module.hot.accept("./ResearchDataTable.vue?vue&type=template&id=524f4c31&scoped=true&", function () {
      api.rerender('524f4c31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchDataTable.vue"
export default component.exports